import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

import DeliverableEditor from "@/components/editors/deliverable.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {useRoute} from "vue-router"
  import {Deliverable as DeliverableClient} from "@/endpoints/rutsolve/gql/resolvers/deliverable"
  import {onBeforeMount, ref} from "vue"
  import {Deliverable} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"
  import Button from "@/components/button.vue"
  import router from "@/router"
  import ConfirmationModal from "@/components/modals/confirmation.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'edit_deliverable',
  setup(__props) {

  const error = ref<Error>(null)
  const deliverableClient = new DeliverableClient()
  const deliverable = ref<Deliverable>(null)
  const confirmRemove = ref<boolean>(false)

  onBeforeMount(() => {
    read()
  })

  async function read() {
    try {
      const deliverableID = useRoute().params.deliverableID.toString()
      deliverable.value = await deliverableClient.summary(deliverableID)
    } catch(e) {
      error.value = e
    }
  }

  async function remove() {
    try {
      await deliverableClient.remove(deliverable.value.id)
      deliverablesRedirect()
    } catch(e) {
      error.value = e
    }
  }

  async function save() {
    try {
      await deliverableClient.update(deliverable.value)
      deliverablesRedirect()
    } catch(e) {
      error.value = e
    }
  }

  function deliverablesRedirect() {
    router.push({
      name: "deliverables"
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(VerticalNavigator, null, {
        default: _withCtx(() => [
          (deliverable.value)
            ? (_openBlock(), _createBlock(Breadcrumb, {
                key: 0,
                links: [{
          title: 'RutSolve',
          routeName: 'index'
        }, {
          title: 'Deliverables',
          routeName: 'deliverables'
        }],
                title: deliverable.value.name
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          _cache[6] || (_cache[6] = _createElementVNode("h1", null, " Edit Deliverable ", -1)),
          _createVNode(DeliverableEditor, {
            value: deliverable.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((deliverable).value = $event))
          }, null, 8, ["value"]),
          _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
          _createVNode(Button, {
            title: "Remove",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (confirmRemove.value = true))
          }),
          _createVNode(Button, {
            title: "Cancel",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (deliverablesRedirect()))
          }),
          _createVNode(Button, {
            title: "Save",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (save()))
          })
        ]),
        _: 1
      }),
      _createVNode(ConfirmationModal, {
        display: confirmRemove.value,
        "onUpdate:display": _cache[4] || (_cache[4] = ($event: any) => ((confirmRemove).value = $event)),
        callback: remove,
        message: "This action will remove selected deliverable.",
        title: "Remove Deliverable"
      }, null, 8, ["display"]),
      (error.value)
        ? (_openBlock(), _createBlock(ErrorModal, {
            key: 0,
            error: error.value,
            "onUpdate:error": _cache[5] || (_cache[5] = ($event: any) => ((error).value = $event))
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})